import basicInformationMutations from './basic-information/mutations';
import educationMutations from './education/mutations';
import languagesMutations from './languages/mutations';
import motivatorsMutations from './motivators/mutations';
import projectsMutations from './projects/mutations';
import skillsMutations from './skills/mutations';
import trainingsMutations from './trainings/mutations';
import workExperienceMutations from './work-experience/mutations';

export default {
  ...basicInformationMutations,
  ...workExperienceMutations,
  ...educationMutations,
  ...projectsMutations,
  ...languagesMutations,
  ...motivatorsMutations,
  ...skillsMutations,
  ...trainingsMutations,
  mutateEditProfileLoadingState(state, loading) {
    state.editProfileLoading = loading;
  },
  mutatePartHasChangesState(state, data) {
    state.partHasChanges = {...state.partHasChanges, ...data};
  }
};
